import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { catchError, Observable, of } from 'rxjs';
import {
  AddressResponse,
  CityListResponse,
  CustomerAddressResponse,
  SubmitResponse,
} from '../../models';
import { AddressInput, UpdateCAddressInput, UpdateCustomerAddressInput } from '../../inputs';

@Injectable({
  providedIn: 'root'
})
export class AddressService extends HttpService<
  AddressInput | UpdateCustomerAddressInput,
  CustomerAddressResponse | AddressResponse
> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'addresses');
  }

  getAllUserAddresses(customerId: number): Observable<AddressResponse[]> {
    return this.getAll().pipe(catchError((error) => of(error)));
  }
  createAddress(address: AddressInput): Observable<SubmitResponse> {
    return this.create(address);
  }

  setDefaultAddress(addressId: string): Observable<SubmitResponse> {
    return this.create(null, `${addressId}/set-default`).pipe(catchError((error) => of(error)));
  }
  updateAddress(address: UpdateCAddressInput, id: string): Observable<SubmitResponse> {
    return this.update(address, id).pipe(catchError((error) => of(error)));
  }
  deleteAddress(addressId: string): Observable<SubmitResponse> {
    return this.delete(addressId).pipe(catchError((error) => of(error)));
  }
  getAllAddressesLocations(): Observable<CityListResponse> {
        return this.getAll('cities').pipe(catchError((error) => of(error)));
    }

}